import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/storage-files/_list/')({
  beforeLoad: () => {
    throw redirect({
      to: '/storage-files/folders'
    });
  }
});